import { render, staticRenderFns } from "./TestimonialsSection.vue?vue&type=template&id=7aab5e12&scoped=true"
import script from "./TestimonialsSection.vue?vue&type=script&setup=true&lang=js"
export * from "./TestimonialsSection.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aab5e12",
  null
  
)

export default component.exports